import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const CAPACITY_EVENT = "fmo:capacity-refresh";

export const useCapacity = (interval = 60000) => {
  const [data, setData] = useState(null);
  const load = useCallback(() => api.get("/admin/capacity").then(({ data: d }) => setData(d)).catch(() => {}), []);
  useEffect(() => {
    load();
    const id = setInterval(load, interval);
    window.addEventListener(CAPACITY_EVENT, load);
    return () => {
      clearInterval(id);
      window.removeEventListener(CAPACITY_EVENT, load);
    };
  }, [load, interval]);
  return [data, load];
};

export const AlertTriangle = ({ level, className = "h-5 w-5" }) => (
  <img src={level === "red" ? "/alert-red.png" : "/alert-orange.png"} alt="" aria-hidden="true" className={`${className} shrink-0`} />
);
